import httpService from "./httpService";
import h from "./h";
import constants from "../constants";
import utils from "./utils";

export default {

  findAllForHcCaseCommands(deptId) {
    let params = { deptId: deptId };
    return httpService.get("department/findAllForHcCaseCommands", { params: params });
  },

  findAllForDongTrinh(keyword, pageable) {
    let params = utils.merge({ keyword: keyword }, utils.initPageableParams(pageable));
    return httpService.get("department/findAllForDongTrinh", { params: params });
  },

  findAllActiveDeptsByParentId(parentId) {
    let params = utils.merge({ parentId: parentId });
    return httpService.get("department/findAllActiveDeptsByParentId", { params: params });
  },

  findAllForAdmin(form, pageable) {
    pageable = utils.initPageableParams(pageable);
    let params = utils.merge(form, pageable);
    return httpService.get("department/findAllForAdmin", { params: params });
  },

  findAll2(example, pagable) {
    let params = utils.merge(example, utils.initPageableParams(pagable))
    return httpService.get("department", { params: params });
  },

  findAll(pagable) {
    return this.findAll2(null, pagable);
  },

  findAllSubDepartments(deptId, includeDept, pagable) {
    pagable = utils.initPageableParams(pagable);
    let params = utils.merge(
      { deptId: deptId, includeDept: includeDept },
      pagable
    );
    return httpService.get("department/findAllSubDepartments", {
      params: params
    });
  },

  findById(id) {
    return httpService.get("department/" + id);
  },

  findAllByIdIn(ids, status) {
    let params = { status: status };
    return httpService.post("department/findAllByIdIn", { ids: ids }, {params: params});
  },

  getUserInDepartment(ids) {
    return httpService.get("department/getUserInDepartment", {
      params: {
        ids: ids
      }
    });
  },

  findByCode(deptCode) {
    return httpService.get("department/findByCode", {
      params: {
        deptCode: deptCode
      }
    });
  },

  search(deptCode, pageable) {
    pageable = utils.initPageableParams(pageable);
    return httpService.get("department/search", {
      params: {
        keyword: deptCode,
        page: pageable.page,
        size: pageable.size,
        sort: pageable.sort
      }
    });
  },

  findParents(id) {
    return httpService.get(`department/${id}/findParents`);
  },

  save(form) {
    return httpService.post(`department`, form);
  },

  update(id, form) {
    return httpService.put(`/department/${id}`, form);
  },

  changeStatus(id, form) {
    return httpService.put(`/department/${id}/changeStatus`, form);
  },

  getParentById(deptId) {
    return httpService.get(`/department/find-parent`, { deptId })
  },

  prepareEditorDepartments(publisherId, departments) {
    let performDepartments = [];

    if (!publisherId || !departments) {
      return (performDepartments = []);
    }

    let publisherDepartment = h.find(
      departments,
      department => department.id === publisherId
    );
    performDepartments = [];
    //thêm đơn vị hiện tại
    performDepartments.push(publisherDepartment);

    /**
     * thêm các đơn vị con cấp dưới;
     */
    if (publisherDepartment) {
      let childDepartments = h.findAll(
        departments,
        department => department.parentId === publisherDepartment.id
      );
      childDepartments && performDepartments.push(...childDepartments);
    }

    if (publisherDepartment.deptType === constants.DEPARTMENT.DEPT_TYPE.DVTT) {
      performDepartments = performDepartments.filter(
        item =>
          item.deptType !== constants.DEPARTMENT.DEPT_TYPE.PBCN ||
          item.deptCode === constants.DEPARTMENT.DEPT_CODE.TCT
      );
    }

    return performDepartments;
  },
  /**
   * filter lại danh sách đơn vị nhận bên trong, chi cho phép ban hành trong đơn vị cha hoặc đơn vị ngang cấp
   * của đơn vị ban hành văn bản;
   */
  prepareReceiveDepartments(publisherId, departments) {
    let receiveDepartments = [];

    if (!publisherId || !departments) {
      return (receiveDepartments = []);
    }

    let publisherDepartment = h.find(
      departments,
      department => department.id == publisherId
    );
    receiveDepartments = [];

    /**
     * thêm đơn vị cha vào danh sách;
     */
    let parentDepartment = h.find(
      departments,
      department => department.id === publisherDepartment.parentId
    );
    parentDepartment && receiveDepartments.push(parentDepartment);

    /**
     * thêm các đơn vị ngang cấp vào danh sách;
     */
    if (parentDepartment) {
      let siblingDepartments = h.findAll(
        departments,
        department => department.parentId === parentDepartment.id
      );
      siblingDepartments && receiveDepartments.push(...siblingDepartments);
    }

    /**
     * thêm các đơn vị con cấp dưới;
     */
    if (publisherDepartment) {
      let childDepartments = h.findAll(
        departments,
        department => department.parentId === publisherId
      );
      childDepartments && receiveDepartments.push(...childDepartments);
    }

    // if (publisherDepartment.deptType === constants.DEPARTMENT.DEPT_TYPE.DVTT) {
    //   receiveDepartments = receiveDepartments.filter(
    //     item =>
    //       item.deptType !== constants.DEPARTMENT.DEPT_TYPE.PBCN ||
    //       item.deptCode === constants.DEPARTMENT.DEPT_CODE.TCT
    //   );
    // }

    return receiveDepartments;
  },

  /**
   * chi lay don vi hien tai & don vi con;
   * @param departmentId
   * @param allDepartments
   * @param includeDeptIds dung cho cac
   * @returns {Array}
   */
  prepareChildDepartments(departmentId, allDepartments, includeDeptIds) {
    let departments = [];
    let department = h.find(allDepartments, item => item.id === departmentId);
    department && departments.push(department);
    let index = 0;
    while (index < departments.length) {
      department = departments[index];
      h.each(
        allDepartments,
        item =>
          item.parentId === department.id &&
          (item.status === constants.DEPARTMENT.STATUS.ACTIVE ||
            (includeDeptIds && includeDeptIds.indexOf(item.id) !== -1)) &&
          departments.push(item)
      );
      index++;
    }
    return departments;
  },

  findAllForBanHanh(docId) {
    return httpService.get("department/findAllForBanHanh", { params: { docId: docId } });
  },

  // searchInAllSubDepartments(keyword, deptId, includeDept, pagable) {
  //   pagable = utils.initPageableParams(pagable);
  //   let params = utils.merge(
  //     {deptId: deptId, keyword: keyword, includeDept: includeDept},
  //     pagable
  //   );
  //   return httpService.get("department/searchInAllSubDepartments", {
  //     params: params
  //   });
  // },
  searchInAllSubDepartments(form, pagable) {
    pagable = utils.initPageableParams(pagable);
    let params = utils.merge(form, pagable);
    return httpService.get("department/search", {
      params: params
    });
  },

  /**
   * filter lại danh sách đơn vị hashtag cho rieng van thu,
   * bao gom cac don vi con va cac don vi ngang cap
   */
  prepareHashTagDepartmentsForVT(publisherId, departments, query) {
    let receiveDepartments = [];

    if (!publisherId || !departments) {
      return (receiveDepartments = []);
    }

    let publisherDepartment = h.find(
      departments,
      department => department.id == publisherId
    );
    receiveDepartments = [];

    if (publisherDepartment) {

      /**  thêm các đơn vị ngang cấp vào danh sách; */
      let siblingDepartments = h.findAll(
        departments,
        department => department.parentId == publisherDepartment.parentId
      );
      siblingDepartments && receiveDepartments.push(...siblingDepartments);

      /** thêm các đơn vị con cấp dưới;*/
      let childDepartments = h.findAll(
        departments,
        department => department.parentId === publisherDepartment.id
      );
      childDepartments && receiveDepartments.push(...childDepartments);

      if (publisherDepartment.deptType && publisherDepartment.deptType === constants.DEPARTMENT.DEPT_TYPE.DVTT) {
        receiveDepartments = receiveDepartments.filter(
          item =>
            item.deptType !== constants.DEPARTMENT.DEPT_TYPE.PBCN ||
            item.deptCode === constants.DEPARTMENT.DEPT_CODE.TCT
        );
      }

      receiveDepartments = receiveDepartments.filter(
        item =>
          item.deptName.toUpperCase().indexOf(query.toUpperCase()) >= 0
      );
    }

    return receiveDepartments;
  },

  findAllTaskBaoCaoTongHopThangReport() {
    return httpService.get("department/findAllTaskBaoCaoTongHopThangReport");
  },

  findAllCurrentAndIncludeSubDepts() {
    return httpService.get("department/findAllCurrentAndIncludeSubDepts");
  },

  findAllForBookDoc() {
    return httpService.get("department/findAllForBookDoc");
  },

  findAllForHcMayBay() {
    return httpService.get("department/findAllForHcMayBay");
  },
};



// WEBPACK FOOTER //
// ./src/services/departmentService.js